import React, { FC } from 'react';
import { ReactComponent as RadioBtnChecked } from '../../../assets/Common/RadioBtnChecked.svg';

export const RadioBtnCheckedIcon: FC = () => <RadioBtnChecked />;
